import React, { useCallback } from "react";
import SearchFeaturePageShell from "components/shell/SearchFeaturePageShell";
import { useShellAppContext } from "features/shell/context/useShellAppContext";
import { useCatalogSync } from "features/home/hooks/useCatalogSync";
import { IndexingStatus } from "features/home/operatorState";
import { useLocalizedMessage } from "util/useLocalizedMessage";
import DescriptionParametersSection from "./DescriptionParametersSection";

export default function DescriptionParametersPage() {
  const { productProfile, compatibility, routeShopId, adminLanguageId, bridgeClient } = useShellAppContext();
  const { status, isStarting, lastSuccessAt, markReindexRequired } = useCatalogSync();
  const t = useLocalizedMessage();
  const source = compatibility?.descriptionParameters;
  const catalogChanged = useCallback(() => markReindexRequired({
    source: "description-parameters", shopId: routeShopId, languageId: adminLanguageId
  }), [markReindexRequired, routeShopId, adminLanguageId]);

  if (productProfile?.id !== "plugin" || source?.available !== true) return null;

  return (
    <DescriptionParametersSection
      standalone
      enabled
      lifecycleEnabled={source.lifecycleAvailable === true}
      normalizationEnabled={source.normalizationAvailable === true}
      bridgeClient={bridgeClient}
      scopeKey={`${routeShopId}:${adminLanguageId}`}
      onCatalogChange={catalogChanged}
      catalogUpdating={status === IndexingStatus.RUNNING || isStarting}
      catalogRefreshKey={lastSuccessAt}
      renderPage={({ actions, children }) => (
        <SearchFeaturePageShell pageId="descriptionParameters" description={t("descriptionParameters.productIntro")} actions={actions}>
          {children}
        </SearchFeaturePageShell>
      )}
    />
  );
}
